import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() listBreadcrumb: any[] = [];
  @Output() currentItem: EventEmitter<any> = new EventEmitter();

  onClick(item) {
    this.currentItem.emit(item);
  }
}
